import React from "react";
import api from "../../../../services/api";
import { format } from "../../../../utils/MoneyFormater";
import CurrencyField from "../../../../components/CurrencyField/index";
import { Tag, Button, DatePicker, notification, Popconfirm } from "antd";
import moment from "moment";

export default class TableRow extends React.Component {
  state = {
    valor_recebido: 0
  };

  componentDidMount = () => {
    this.handleGetParcela();
  };

  handleGetParcela = async () => {
    //console.log(this.props);
    let url = `/parcela/?num_parcela=${parseInt(this.props.data["Num.Parc"])}&`;
    url = url + `acordo__pasta__pasta=${this.props.data["Pasta"]}&`;
    url = url + "acordo__status_acordo__in=ATIVO,Quitado";
    url =
      url +
      "&data_vencimento=" +
      moment(this.props.data["Dt.Venc."]).format("YYYY-MM-DD");
    let res = await api.get(url);
    //console.log(res);
    if (res.data.results.length == 1) {
      let parcela = res.data.results[0];
      parcela.data_vencimento = this.props.data["Dt.Receb."];
      parcela.valor_pago = this.props.data["Vlr.Recebido"];
      let valor_recebido = this.props.data["Vlr.Recebido"];
      if (res.data.results[0].tipo_acordo.includes("S/")) {
        console.log("entrou aqui");
        valor_recebido = this.props.data["Vlr.Honor."] * 5;
      }
      this.setState({
        parcela: parcela,
        valor_recebido: valor_recebido
      });
    }
  };

  handleOnChangeParcela = valor => {
    let parcela = this.state.parcela;
    parcela.valor_pago = valor;
    this.setState({ parcela: parcela });
  };

  handleOnChangeDate = date => {
    let parcela = this.state.parcela;
    parcela.data_pagamento = date.format("YYYY-MM-DD");
    this.setState({ parcela: parcela });
  };

  pagar_parcela = async e => {
    let params = {
      valor_pago: this.state.valor_recebido,
      data_pagamento:
        this.state.parcela.data_pagamento == null
          ? this.props.data["Dt.Receb."]
          : this.state.parcela.data_pagamento,
      status_parcela: 1
    };

    await api
      .put(`/parcela/${this.state.parcela.id}/`, params)
      .then(result => {
        notification.open({
          message: "Parcela atualizada com sucesso."
        });
        let parcela = this.state.parcela;
        parcela.status_parcela = "1";
        this.setState({ parcela: parcela });
      })
      .catch(err => {
        console.log(err);
        notification.error({
          message: "Ocorreu um erro."
        });
      });
  };

  despagar_parcela = async e => {
    let params = {
      valor_pago: null,
      data_pagamento: null,
      status_parcela: 0
    };
    await api
      .put(`/parcela/${this.state.parcela.id}/`, params)
      .then(result => {
        notification.open({
          message: "Parcela atualizada com sucesso."
        });
        let parcela = this.state.parcela;
        parcela.status_parcela = "0";
        this.setState({ parcela: parcela });
      })
      .catch(err => {
        console.log(err);
        notification.error({
          message: "Ocorreu um erro."
        });
      });
  };

  render() {
    let button = "";
    console.log("estado", this.state);
    console.log("props", this.props);
    if ("parcela" in this.state) {
      if (this.state.parcela.status_parcela == "0") {
        button = (
          <Button type="primary" onClick={this.pagar_parcela}>
            Receber
          </Button>
        );
      } else {
        button = (
          <Popconfirm
            title={"Tem certeza que deseja cancelar o pagamento?"}
            onConfirm={this.despagar_parcela}
            okText="Sim"
            cancelText="Não"
          >
            <Button type="danger">Cancelar Recebimento</Button>
          </Popconfirm>
        );
      }
    } else {
      button = <Tag color="red">Parcela não encontrada</Tag>;
    }
    return (
      <React.Fragment>
        <tr>
          <td>{this.props.data.Pasta}</td>
          <td>
            {"parcela" in this.state ? this.state.parcela.tipo_acordo : ""}
          </td>
          <td>{this.props.data["Num.Parc"]}</td>
          <td>
            {"parcela" in this.state
              ? `R$ ${format(this.state.parcela.valor_parcela)}`
              : ""}
          </td>
          <td>
            {"parcela" in this.state ? this.state.parcela.data_vencimento : ""}
          </td>
          <td>
            <DatePicker
              onChange={this.handleOnChangeDate}
              format="YYYY-MM-DD"
              defaultValue={moment(this.props.data["Dt.Receb."])}
              disabled={"parcela" in this.state ? false : true}
            />
          </td>
          <td>
            <CurrencyField
              name="currency"
              className="ant-input"
              onChangeEvent={this.handleOnChangeParcela}
              initialValue={this.state.valor_recebido}
              fieldValue={this.state.valor_recebido}
              value={this.state.valor_recebido}
              disabled={"parcela" in this.state ? false : true}
            />
          </td>
          <td>{button}</td>
        </tr>
      </React.Fragment>
    );
  }
}



// WEBPACK FOOTER //
// ./src/pages/Acordo/PagarParcelas/components/table_row.js